import clsx from 'clsx'

export function DemoButton({
  theme = 'dark',
  label = 'Book a Demo',
}: {
  theme?: 'dark' | 'light'
  label?: string
}) {
  let themeClasses = ''
  if (theme === 'dark') {
    themeClasses = 'bg-brand-blue text-white hover:bg-brand-navy'
  } else {
    themeClasses = 'bg-white text-brand-blue hover:bg-white/90'
  }
  return (
    <button
      className={clsx(
        'px-8 py-3 text-sm font-semibold no-underline transition-colors rounded border-0 cursor-pointer whitespace-nowrap',
        themeClasses,
      )}
      onClick={() =>
        window.open('https://m.urbanintelligence.co.nz/meetings/resilience-explorer/demo', '_blank')
      }
    >
      {label}
    </button>
  )
}
